import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {INavigationItems, INavigationType} from "../../../navigation.interface";
import {MenuItemCategories} from "../../../navigation.enum";

@Component({
    selector: 'db-ecommerce-menu-search',
    templateUrl: './ecommerce-menu-search.component.html',
    styleUrls: ['./ecommerce-menu-search.component.scss'],
    standalone: false
})
export class EcommerceMenuSearchComponent implements OnInit {
  @Input() allTypeItems: INavigationItems;
  @Output() addNewMenuItem: EventEmitter<INavigationType> = new EventEmitter<INavigationType>();

  @Input() set searchTerm(value: string) {
    if (value) {
      this.searchResult = this.filterDataByTitle(this.allTypeItems, value);
    }
  }
  types = MenuItemCategories;

  searchResult: INavigationType[] = [];

  constructor() {
  }

  ngOnInit() {
  }

  filterDataByTitle(data, searchTitle: string): INavigationType[] {
    const result = [];

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const items = data[key].filter((item) => item.title.toLowerCase().includes(searchTitle.toLowerCase()));
        result.push(...items);
      }
    }

    return result;
  }

}
